import { createRouter, createWebHistory } from 'vue-router';
import TCMathGamePage from '../views/TCMathGamePage.vue';

const routes = [
  {
    path: '/',
    name: 'TCMathGamePage',
    component: TCMathGamePage,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
